interface AreaChartProps {
  data: { date: string; value: number }[];
  height?: number;
  color?: string;
  showDots?: boolean;
  showGradient?: boolean;
}

export function AreaChart({
  data,
  height = 200,
  color = 'hsl(var(--primary))',
  showDots = true,
  showGradient = true,
}: AreaChartProps) {
  if (data.length === 0) return null;

  const maxValue = Math.max(...data.map((d) => d.value));
  const minValue = Math.min(...data.map((d) => d.value));
  const range = maxValue - minValue || 1;
  const chartHeight = height - 40;

  const points = data.map((d, i) => {
    const x = (i / (data.length - 1)) * 100;
    const y = chartHeight - ((d.value - minValue) / range) * (chartHeight - 20);
    return { x, y, value: d.value, date: d.date };
  });

  const pathD = points.map((p, i) => (i === 0 ? `M ${p.x} ${p.y}` : `L ${p.x} ${p.y}`)).join(' ');

  const areaD = `${pathD} L 100,${chartHeight} L 0,${chartHeight} Z`;

  const gradientId = `areaGradient-${color.replace(/[^a-z0-9]/gi, '')}`;

  return (
    <div className="w-full" style={{ height }}>
      <svg viewBox={`0 0 100 ${chartHeight}`} preserveAspectRatio="none" className="w-full h-full">
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={showGradient ? 0.3 : 0} />
            <stop offset="100%" stopColor={color} stopOpacity={showGradient ? 0 : 0} />
          </linearGradient>
        </defs>
        <path d={areaD} fill={`url(#${gradientId})`} />
        <path
          d={pathD}
          fill="none"
          stroke={color}
          strokeWidth="2"
          vectorEffect="non-scaling-stroke"
        />
        {showDots &&
          points.map((p, i) => (
            <circle
              key={i}
              cx={p.x}
              cy={p.y}
              r="3"
              fill={color}
              className="transition-all duration-300 hover:r-4"
            />
          ))}
      </svg>
      <div className="flex justify-between text-xs text-muted-foreground mt-2 px-1">
        {data.slice(0, 5).map((d, i) => (
          <span key={i}>{d.date.slice(5)}</span>
        ))}
      </div>
    </div>
  );
}
